import { Text } from 'react-native'
import styled from 'styled-components'
import { colors } from 'infra/color'
import { CURRENT_OS, OS } from 'infra/constant'

export const DEFAULT_FONT_FAMILY = 'SUIT'

export const BaseText = styled(Text)`
  font-family: ${DEFAULT_FONT_FAMILY};
  color: ${colors.black};
`

const LINE_HEIGHT_MULTIPLE = 1.3
// RN 업데이트하고 NEW ARCHITECTURE 로 넘어오면서 갑자기 폰트가 커졌는데 이걸 다시 줄이기 위함
const FONT_SIZE_SCALER = CURRENT_OS === OS.ANDROID ? 0.8 : 1
const FONT_SIZE = {
  H1: 26 * FONT_SIZE_SCALER,
  H2: 20 * FONT_SIZE_SCALER,
  H3: 18 * FONT_SIZE_SCALER,
  Body1: 16 * FONT_SIZE_SCALER,
  Body2: 14 * FONT_SIZE_SCALER,
  Body3: 12 * FONT_SIZE_SCALER,
  Caption: 12 * FONT_SIZE_SCALER,
  OverLine: 10 * FONT_SIZE_SCALER,
  SectionTitle: 14 * FONT_SIZE_SCALER,
}

export const getLegacyFontStyle = (
  fontSize: number,
  lineHeightMultiple: number = LINE_HEIGHT_MULTIPLE,
) => {
  return {
    fontSize: fontSize * FONT_SIZE_SCALER,
    lineHeight: fontSize * FONT_SIZE_SCALER * lineHeightMultiple,
  }
}

export const H1 = styled(BaseText)`
  font-size: ${FONT_SIZE.H1}px;
  line-height: ${FONT_SIZE.H1 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 800;
`

export const H2 = styled(BaseText)`
  font-size: ${FONT_SIZE.H2}px;
  line-height: ${FONT_SIZE.H2 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 400;
`

export const H3 = styled(BaseText)`
  font-size: ${FONT_SIZE.H3}px;
  line-height: ${FONT_SIZE.H3 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 400;
`

export const Body1 = styled(BaseText)`
  font-size: ${FONT_SIZE.Body1}px;
  line-height: ${FONT_SIZE.Body1 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 500;
`

export const Body2 = styled(BaseText)`
  font-size: ${FONT_SIZE.Body2}px;
  line-height: ${FONT_SIZE.Body2 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 500;
`

export const Body3 = styled(BaseText)`
  font-size: ${FONT_SIZE.Body3}px;
  line-height: ${FONT_SIZE.Body3 * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 500;
`

export const Caption = styled(BaseText)`
  font-size: ${FONT_SIZE.Caption}px;
  line-height: ${FONT_SIZE.Caption * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 400;
`

export const OverLine = styled(BaseText)`
  font-size: ${FONT_SIZE.OverLine}px;
  line-height: ${FONT_SIZE.OverLine * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 400;
`

export const ButtonText = styled(Body1)`
  font-weight: 700;
  color: ${colors.white};
`

export const SectionTitle = styled(BaseText)`
  font-size: ${FONT_SIZE.SectionTitle}px;
  line-height: ${FONT_SIZE.SectionTitle * LINE_HEIGHT_MULTIPLE}px;
  font-weight: 700;
  color: ${colors.gray.v500};
`
